import GlobalContext from '../bootstrap';
import initTypeaheads from '../typeahead';
import initInformationSearch from '../infosearch';
import initPagination from '../pagination';
import initInputEnablers from '../forms/input-enabler';

class InformationPage extends GlobalContext {
    constructor() {
        super();
        this._initialiseComponents();
    }

    _initialiseComponents(): void {
        initTypeaheads();

        initInputEnablers();

        initInformationSearch();

        if ( document.body.classList.contains( 'twc__pagination' ) ) {
            initPagination( document.body );
        }
    }
}

if ( !window.infopage ) {
    window.infopage = new InformationPage();
}
